import React from 'react';

import { SetupMfaPageContent } from 'src/components/account';
import { DetailPageLayout } from 'src/components/common';

export const SetupMfaPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Multi-factor Authentication">
      <SetupMfaPageContent />
    </DetailPageLayout>
  );
};
